$(document).ready(function(){
	ScrollTop();
    // fixed header
    $(window).scroll(function(){
        ScrollTop();
    });

    // show box chat
    $(".box-live").click(function(){
        if($(this).hasClass("change-icon")){
            $(this).removeClass("change-icon");
            $(".box-chat").fadeOut();
        }
        else{
            $(this).addClass("change-icon");
            $(".box-chat").fadeIn();
        }
    });
    // hide box chat
    $(".btn-hide-chat,.btn-close-chat").click(function(){
        $(".box-chat").fadeOut();
        $(".box-live").removeClass("change-icon");
    })
    // show box send message
    $(".btn-submit").click(function(){
        $(".box-send-message").fadeIn();
        $(".box-regis").fadeOut();
    });
    $(".back-send-mess").click(function(){
        $(".box-attach-file").fadeOut();
        $(".box-send-message").fadeIn();
    });
    // attach file
    $(".attach-file").change(function(){
        $(".box-send-message").fadeOut();
        $(".box-attach-file").fadeIn();
    });
    // show popup
    $(".btn-full-box").click(function(){
        $(".livechat-1 .box-chat").fadeOut();
        $(".box-live").removeClass("change-icon");
    });
    $(".modal-dialog .close").click(function(){
        $(".box-regis").fadeIn();
        $(".box-send-message,.box-attach-file").fadeOut();
    });

    // custom scroll bar
    $(".scroll-body-chat").mCustomScrollbar();
});
function ScrollTop(){
    var scrolls = $(window).scrollTop();
    if (scrolls >= 30){
       $("body").addClass("fixed-head");
    }
    else{
        $("body").removeClass("fixed-head");
    }
}

$(function() {
    $(document).on('change', ':file', function() {
        var input = $(this),
            numFiles = input.get(0).files ? input.get(0).files.length : 1,
            label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
        input.trigger('fileselect', [numFiles, label]);
    });

    $(':file').on('fileselect', function(event, numFiles, label) {
        var input = $(this).parents('.input-group').find(':text'),
            log = numFiles > 1 ? numFiles + ' files selected' : label;
        if( input.length ) {
            input.val(log);
        } else {
            if( log ) alert(log);
          }
    });
}); 